import React, { useMemo } from 'react';
import CustomPageDropdown from 'components/appbar/desktop/CustomPageDropdown';
import CustomPageLink from 'components/appbar/CustomPageLink';
import ViewMoreDropdown from 'components/appbar/desktop/ViewMoreDropdown';
import styled from 'styled-components';
import { CustomPageGroup } from 'models/types/customPage';
import useMenuItems from 'components/appbar/useMenuItems';

const TopBarHorizontalLinks = styled.div`
  display: inline-block;
`;

export interface AppBarCustomPagesProps {
  defaultCustomPages?: CustomPageGroup[];
  showMoreFrom?: number;
  keepMounted?: boolean;
  hideCustomPages?: boolean;
}

const AppBarCustomPages = ({
  showMoreFrom = Number.MAX_SAFE_INTEGER,
  keepMounted = false,
}: AppBarCustomPagesProps) => {
  const validCustomPages = useMenuItems();

  const [renderItems, showMoreItems] = useMemo(() => {
    const list = [[], []];
    validCustomPages.forEach((item, index) => list[Number(index >= showMoreFrom)].push(item));
    const result = [keepMounted ? [...validCustomPages] : list[0], list[1]];
    result[0].push({ viewMore: true });
    return result;
  }, [keepMounted, showMoreFrom, validCustomPages]);

  return (
    <>
      {renderItems.map((pageData, index) => {
        const {
          pages, display, viewMore,
        } = pageData;
        if (viewMore) return <ViewMoreDropdown key={index} items={showMoreItems} />;
        switch (display) {
          case 'TOPBAR':
            return (
              <TopBarHorizontalLinks key={index} id={`custom-page-group-${index}`}>
                {pages.map((page: any) => <CustomPageLink key={page.name} {...page} />)}
              </TopBarHorizontalLinks>
            );
          case 'DROPDOWN':
            return (
              <CustomPageDropdown
                key={index}
                {...pageData}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default AppBarCustomPages;
